import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { AnyAction, Store, applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { SESSION_KEY_APP_STATE } from '../lib/constants';
import { saveStorageData } from '../lib/persistance/storage';
import { AppState } from '../types/redux';
import { createRootReducer } from './reducers';

export const history = createBrowserHistory();

// tslint:disable-next-line:no-any
export function initStore(preloadedState?: any): Store<AppState> {
	const composeEnhancer: typeof compose =
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
	const store = createStore<AppState, AnyAction, unknown, unknown>(
		createRootReducer(history),
		preloadedState,
		composeEnhancer(applyMiddleware(routerMiddleware(history), thunk))
	);

	store.subscribe(() => {
		saveStorageData(SESSION_KEY_APP_STATE, store.getState());
	});

	// Hot reloading
	// @ts-ignore
	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		// @ts-ignore
		module.hot.accept('./reducers', () => {
			store.replaceReducer(createRootReducer(history));
		});
	}

	return store;
}
